var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserVerificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360.344,
    height: 428.16,
    viewBox: "0 0 360.344 428.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(-33.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19405",
    "data-name": "Path 19405",
    d: "M393.8,110.208c-.512-11.264-.512-22.016-.512-32.768a15.086,15.086,0,0,0-15.36-15.36c-64,0-112.64-18.432-153.088-57.856a15.8,15.8,0,0,0-21.5,0C162.888,43.648,114.248,62.08,50.248,62.08a15.086,15.086,0,0,0-15.36,15.36c0,10.752,0,21.5-.512,32.768-2.048,107.52-5.12,254.976,174.592,316.928l5.12,1.024,5.12-1.024C398.408,365.184,395.848,218.24,393.8,110.208ZM201.8,259.2a16.523,16.523,0,0,1-10.752,4.1h-.512a14.41,14.41,0,0,1-10.752-5.12L132.168,205.44l23.04-20.48,37.376,41.472,82.944-78.848,20.992,22.528Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVerificationIcon);
export default __webpack_public_path__ + "static/media/user_verification_icon.31945d0cd34087be5c55154c8ba5d595.svg";
export { ForwardRef as ReactComponent };